import React from "react"
import {FiltersPanelContainer} from "../components"
import {TabbedFilterContainer} from "../tabbedFiltersPanel/components"
import {SortingOption} from "../../../models/Sorting"
import connect from "./connect"
import {TabbedFilter} from "../tabbedFilter"
import {SCORE, SORT} from "../../../config/constants"

export interface SortTabbedFilterProps {
    selected: string
    options: SortingOption[]
    siteUrl: string
    setSelectedSort: (newValue: string) => void
}

export const handleFilterSelect = (value: string, selected: string, setSelectedSort: (newValue: string) => void) => {
    // force sort to always default to "score" if no other option chosen
    if (selected === value && selected === SCORE) return
    if (selected === value) {
        setSelectedSort(SCORE)
    } else {
        setSelectedSort(value)
    }
}

export const SortTabbedFilter = ({selected, options, siteUrl, setSelectedSort}: SortTabbedFilterProps) => {
    return (
        <FiltersPanelContainer data-testid="plp-tabbed-facets-panel">
            <TabbedFilterContainer>
                {options.map(({name, value}) => (
                    <TabbedFilter
                        facetName={SORT}
                        filterState={{n: name, v: value, s: value === selected, d: false, incompatibleWith: []}}
                        key={value}
                        onFilterSelect={() => handleFilterSelect(value, selected, setSelectedSort)}
                        siteUrl={siteUrl}
                    />
                ))}
            </TabbedFilterContainer>
        </FiltersPanelContainer>
    )
}

export default connect(SortTabbedFilter)
